import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Loading from '../features/uiStatus/components/Loading';
import { useLoading } from '../features/uiStatus/hooks/useLoading';
import { useAuth } from '../features/accounts/contexts/AuthContext';

const ProtectedRoute = () => {
    const { isLoading, setLoading } = useLoading();
    const { user, loading } = useAuth();

    // 認証コンテキストのローディングが完了したら、useLoadingも更新
    useEffect(() => {
        if (!loading) {
            setLoading(false);
        }
    }, [loading, setLoading]);

    // 認証コンテキストがローディング中の場合
    if (loading) {
        return (
            <Loading
                isLoading={true}
                fullscreen
                message="認証中..."
            />
        );
    }

    return (
        <Loading isLoading={isLoading} fullscreen message="読み込み中...">
            {user ? <Outlet /> : <Navigate to="/login" replace />}
        </Loading>
    );
};

export default ProtectedRoute;
